module.exports = __webpack_public_path__ + "static/media/trapezoid1.33afb24d.jpg";